import HelloWorld from './components/HelloWorld'
import WebsocketDemo from './components/ws/WebsocketDemo'
import Auth0Login from "./components/auth/Auth0Login"
import PlaceHolderLoading from "./components/placeholder-loading/PlaceHolderLoading"

export default [
  {path: '/hello', component: HelloWorld},
  {path: '/ws', component: WebsocketDemo},
  {path: '/auth', component: Auth0Login},
  {path: '/placeholder', component: PlaceHolderLoading},
]
